// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bj7IHs {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  background: var(--neutral-dark-opacity-50, rgba(0, 0, 0, 0.5));
  box-sizing: border-box;
  animation: bzUkuR 0.2s ease-out;
}

.m7pgwA {
  display: flex;
  flex-direction: column;
  max-width: 90vw;
  max-height: 90vh;
  min-width: 300px;
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  overflow: hidden;
  animation: K2il1f 0.2s ease-out;
  border: none;
}

.EhlKNe {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: var(--spacing-3, 24px) var(--spacing-3, 24px) 0 var(--spacing-3, 24px);
  min-height: 53px;
  width: 100%;
  box-sizing: border-box;
}

.mmwFPu {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.mnYLHa {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-xl, 20px);
  color: var(--text-neutral-dark, #333333);
  text-align: left;
  margin: 0;
  flex: 1;
}

.Qz_LX9 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 20px;
  color: var(--text-neutral-strong, #4d4d4d);
  text-align: left;
  margin: 0;
}

.NCPCE2 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  color: var(--text-neutral-dark, #333333);
  cursor: pointer;
  border: none;
  background: none;
  border-radius: var(--radius-s, 4px);
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  margin-left: var(--spacing-2, 16px);
  align-self: flex-start;
}

.NCPCE2:hover {
  background-color: var(--surface-neutral-subtle, #f5f5f5);
}

.NCPCE2:focus {
  outline: 2px solid var(--brand-tr-orange, #d64000);
  outline-offset: 2px;
}

.s5HfGM {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--spacing-3, 24px);
  box-sizing: border-box;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .m7pgwA {
    max-width: 95vw;
    min-width: 280px;
    margin: var(--spacing-2, 16px);
  }

  .EhlKNe {
    padding: var(--spacing-2, 16px) var(--spacing-2, 16px) 0 var(--spacing-2, 16px);
  }

  .s5HfGM {
    padding: var(--spacing-2, 16px);
  }

  .mnYLHa {
    font-size: var(--font-size-lg, 18px);
  }
}

@keyframes K2il1f {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes bzUkuR {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Modal/Modal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8DAA8D;EAC9D,sBAAsB;EACtB,+BAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;EACjD,mCAAmC;EACnC,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;EAChB,+BAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,+EAA+E;EAC/E,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;EAChB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,sCAAsC;EACtC,sBAAsB;EACtB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,+EAA+E;EACjF;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  background: var(--neutral-dark-opacity-50, rgba(0, 0, 0, 0.5));\n  box-sizing: border-box;\n  animation: backdropFadeIn 0.2s ease-out;\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  max-width: 90vw;\n  max-height: 90vh;\n  min-width: 300px;\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 8px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  box-sizing: border-box;\n  overflow: hidden;\n  animation: modalFadeIn 0.2s ease-out;\n  border: none;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: var(--spacing-3, 24px) var(--spacing-3, 24px) 0 var(--spacing-3, 24px);\n  min-height: 53px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.titleContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-xl, 20px);\n  color: var(--text-neutral-dark, #333333);\n  text-align: left;\n  margin: 0;\n  flex: 1;\n}\n\n.subtitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 20px;\n  color: var(--text-neutral-strong, #4d4d4d);\n  text-align: left;\n  margin: 0;\n}\n\n.closeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n  color: var(--text-neutral-dark, #333333);\n  cursor: pointer;\n  border: none;\n  background: none;\n  border-radius: var(--radius-s, 4px);\n  transition: background-color 0.2s ease;\n  box-sizing: border-box;\n  margin-left: var(--spacing-2, 16px);\n  align-self: flex-start;\n}\n\n.closeButton:hover {\n  background-color: var(--surface-neutral-subtle, #f5f5f5);\n}\n\n.closeButton:focus {\n  outline: 2px solid var(--brand-tr-orange, #d64000);\n  outline-offset: 2px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: var(--spacing-3, 24px);\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n@media (max-width: 768px) {\n  .modal {\n    max-width: 95vw;\n    min-width: 280px;\n    margin: var(--spacing-2, 16px);\n  }\n\n  .header {\n    padding: var(--spacing-2, 16px) var(--spacing-2, 16px) 0 var(--spacing-2, 16px);\n  }\n\n  .body {\n    padding: var(--spacing-2, 16px);\n  }\n\n  .title {\n    font-size: var(--font-size-lg, 18px);\n  }\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes backdropFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `Bj7IHs`,
	"backdropFadeIn": `bzUkuR`,
	"modal": `m7pgwA`,
	"modalFadeIn": `K2il1f`,
	"header": `EhlKNe`,
	"titleContainer": `mmwFPu`,
	"title": `mnYLHa`,
	"subtitle": `Qz_LX9`,
	"closeButton": `NCPCE2`,
	"body": `s5HfGM`
};
module.exports = ___CSS_LOADER_EXPORT___;
